/*
Componente de interfaz gráfica para implementar el Nit y dígito de verificación. 
Recibe el valor del nit vía props.
Al especificar un Nit de 9 dígitos, calcula el dígito de verificación y lo muestra.
Devuelve el Nit y dígito de verificación a través de la función onChange.
*/
import React from "react";
import { useState, useEffect } from "react";

function CampoNit(props) {

    const [valorNit, setValorNit] = useState(props.valor);
    const [digitoVerificacion, setDigitoVerificacion] = useState();
    const inputClassName = props.inputClassName || 'form-control';
    /* ancho fijo DV (rem); props ancho* conservados por compatibilidad, sin % en flex */
    const dvBasisRem =
        props.dvBasisRem != null
            ? props.dvBasisRem
            : props.anchoDigito != null
              ? Math.max(3.25, Math.min(6, parseInt(props.anchoDigito, 10) / 10))
              : 4.5;

    const handleValorNit = (nit) => {

        setValorNit(nit);
        let dv = calcularDigitoVerificacion(nit);
        setDigitoVerificacion(dv);
        props.onChange(nit, dv);
    }

    useEffect(() => {
        const v = props.valor != null && props.valor !== undefined ? String(props.valor).trim() : '';
        const dv = calcularDigitoVerificacion(v);
        setDigitoVerificacion(dv === '' ? undefined : dv);
        if (typeof props.onChange === 'function') {
            props.onChange(v, dv === '' ? '' : dv);
        }
    }, [props.valor]);


    return (
        <div
            className="campo-nit-flex"
            style={{
                width: '100%',
                minWidth: 0,
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'flex-start',
                gap: '0.5rem',
            }}
        >
            <div className="form-group campo-nit-main mb-0" style={{ flex: '1 1 0', minWidth: 0 }}>
                <label htmlFor="numeroDocumento">NIT/Documento</label>
                <input
                    type="text"
                    name="numeroDocumento"
                    className={inputClassName}
                    id="numeroDocumento"
                    defaultValue={props.valor}
                    onChange={(e) => handleValorNit(e.target.value)}
                    style={{ minWidth: 0, width: '100%' }}
                />
            </div>
            <div
                className="form-group campo-nit-dv mb-0"
                style={{ flex: `0 0 ${dvBasisRem}rem`, minWidth: 0 }}
            >
                <label htmlFor="digitoVerificacion">DV</label>
                <input
                    type="text"
                    name="company-address"
                    className={inputClassName}
                    id="digitoVerificacion"
                    value={digitoVerificacion}
                    style={{ textAlign: 'center', minWidth: 0, width: '100%' }}
                />
            </div>
        </div>
    );
}
export default CampoNit;


function calcularDigitoVerificacion(nit) {
    const s = String(nit ?? '').trim();
    if (s.length < 9) {
        return '';
    }
    const base = s.slice(0, 9);
    if (!/^\d{9}$/.test(base)) {
        return '';
    }

    let n1 = parseInt(base[0]);
    let n2 = parseInt(base[1]);
    let n3 = parseInt(base[2]);
    let n4 = parseInt(base[3]);
    let n5 = parseInt(base[4]);
    let n6 = parseInt(base[5]);
    let n7 = parseInt(base[6]);
    let n8 = parseInt(base[7]);
    let n9 = parseInt(base[8]);

    let sumatoria = n1 * 41 + n2 * 37 + n3 * 29 + n4 * 23 + n5 * 19 + n6 * 17 + n7 * 13 + n8 * 7 + n9 * 3;
    let mod = sumatoria % 11;
    let dv = mod;

    if (mod > 1) {
        dv = 11 - mod;
    }

    if (isNaN(dv)) {
        return '';
    }
    else {
        return dv;
    }
}